/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportDto } from '../../models/report-dto';

export interface GetSignalSolvencyReport$Params {
  customerGUID: string;
  endOfExtendedMonitoring: string;
}

export function getSignalSolvencyReport(http: HttpClient, rootUrl: string, params: GetSignalSolvencyReport$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportDto>> {
  const rb = new RequestBuilder(rootUrl, getSignalSolvencyReport.PATH, 'get');
  if (params) {
    rb.query('customerGUID', params.customerGUID, {});
    rb.query('endOfExtendedMonitoring', params.endOfExtendedMonitoring, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportDto>;
    })
  );
}

getSignalSolvencyReport.PATH = '/crefo/report/signal-solvency';
